import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {
  ManifestoGaiolaOutput,
  ManifestoGaiolaInput,
  obterDadosPedidosGaiolaInput,
  obterDadosPedidosGaiolaOutput,
  obterLogsGaiolaInput,
  obterLogsGaiolaOutput,
  obterProdutosGaiolaOutput,
  obterProdutosGaiolaInput,
  VerificarAssociacaoPedidoResponse,
  AssociarPedidoResponse,
  VerificarDesassociacaoPedidoResponse,
  AssociarVolumeRequest,
  VerificarDesassociacaoPedidoRequest,
  obterVolumesNaoCompletosGaiolaInput,
  obterVolumesNaoCompletosGaiolaOutput,
  obterIntervencaoGaiolaInput
} from 'src/app/@shared/models/gaiola.model';
import { Rampa, Agente, Sorter, RampaConfiguracaoInput, RampaConfiguracaoOutput, ConsultaVolumeOutput } from 'src/app/@shared/models/gaiolas.model';
import { RampaConfiguracaoDashboardItem } from 'src/app/@shared/models/sorter-dashboard.model';
import { ValidarManifestoTransferenciaResponse } from 'src/app/@shared/models/manifesto-transferencia.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtro = (obj: obterProdutosGaiolaInput) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
}

@Injectable({
  providedIn: 'root'
})
export class GaiolaService {

  constructor(private http: HttpClient) { }

  selecionarSorters(): Observable<any> {
    return this.http.post<Sorter[]>(`Sorter/Selecionar`, httpOptions);
  }

  selecionarRampas(): Observable<any> {
    return this.http.post<Rampa[]>(`Sorter/SelecionarRampas`, httpOptions);
  }

  selecionarConfiguracoesRampas(input: any): Observable<any> {
    return this.http.post<RampaConfiguracaoDashboardItem[]>(`Sorter/SelecionarConfiguracoesRampasGaiolas`, input, httpOptions);
  }

  selecionarRampa(rampaId: number): Observable<any> {
    return this.http.get<Rampa>(`Sorter/SelecionarRampa/${rampaId}`, httpOptions);
  }

  selecionarAgentesDisponiveis(sorterId?: number): Observable<any> {
    return this.http.get<Agente[]>(`Sorter/SelecionarAgentesDisponiveis/${sorterId || ''}`, httpOptions);
  }

  validarAbrirGaiolas(rampaId: number, input: RampaConfiguracaoInput): Observable<RampaConfiguracaoOutput> {
    return this.http.post<RampaConfiguracaoOutput>(`Sorter/ValidarConfiguracaoRampa/${rampaId}`, input, httpOptions);
  }

  validarAbrirGaiolasPreconfig(rampaId: number, input: RampaConfiguracaoInput): Observable<RampaConfiguracaoOutput> {
    return this.http.post<RampaConfiguracaoOutput>(`SetupGaiolaController/ValidarConfiguracaoRampaComPreConfig/${rampaId}`, input, httpOptions);
  }

  abrirGaiolas(rampaId: number, input: RampaConfiguracaoInput): Observable<RampaConfiguracaoOutput> {
    return this.http.post<RampaConfiguracaoOutput>(`Sorter/AbrirConfiguracaoRampa/${rampaId}`, input, httpOptions);
  }

  abrirGaiolasPreconfig(rampaId: number, input: RampaConfiguracaoInput): Observable<RampaConfiguracaoOutput> {
    return this.http.post<RampaConfiguracaoOutput>(`SetupGaiolaController/AbrirConfiguracaoRampaComPreConfig/${rampaId}`, input, httpOptions);
  }

  encerrarGaiola(sorterId: number, gaiola: string): Observable<Boolean> {
    return this.http.post<Boolean>(`Sorter/EncerrarGaiola/${sorterId}/${gaiola}`, httpOptions);
  }

  selecionarGaiolas(obj: any): Observable<any> {
    return this.http.post<any[]>(`Gaiola/SelecionarGaiolas/`, obj, httpOptions);
  }

  listarUsuarios(): Observable<any> {
    return this.http.get<any[]>(`Gaiola/ListarUsuarios`, httpOptions);
  }

  listarStatus(): Observable<any> {
    return this.http.get<any[]>(`Gaiola/listarStatus`, httpOptions);
  }

  emitirGaiola(obj: any): Observable<any> {
    return this.http.post<any[]>(`Gaiola/EmitirGaiola`, obj, httpOptions);
  }


  consultarVolume(volume: string): Observable<ConsultaVolumeOutput> {
    return this.http.get<ConsultaVolumeOutput>(`Sorter/ConsultarVolume/${volume}`, httpOptions);
  }

  reimprimir(obj: any): Observable<any> {
    return this.http.post<any[]>(`Gaiola/Reimprimir`, obj, httpOptions);
  }

  selecionarManifestoVinculadoAoContainer(containerUnique: string): Observable<HttpResponse<ManifestoGaiolaOutput>> {
    return this.http.get<ManifestoGaiolaOutput>(
      `Gaiola/SelecionarManifestoVinculadoAoContainer/${containerUnique}`,
      { observe: 'response' }
    );
  }

  gerarManifestoGaiola(manifestoGaiolaInput: ManifestoGaiolaInput): Observable<any> {
    return this.http.post<any>(`Gaiola/GerarManifestoGaiola`, manifestoGaiolaInput, httpOptions);
  }

  reimprimirMT(obj: any): Observable<any> {
    return this.http.post<any[]>(`Gaiola/ReimprimirMT`, obj, httpOptions);
  }

  gerarManifestoGaiolaAntigo(manifestoGaiolaInput: ManifestoGaiolaInput): Observable<any> {
    return this.http.post(`Gaiola/GerarManifestoGaiolaAntigo`, manifestoGaiolaInput, httpOptions) as Observable<any>;
  }

  reimprimirMTAntigo(obj: any): Observable<any> {
    return this.http.post<any[]>(`Gaiola/ReimprimirMTAntigo`, obj, httpOptions);
  }

  gerarReManifestoGaiola(manifestoGaiolaInput: ManifestoGaiolaInput): Observable<any> {
    return this.http.post(`Gaiola/GerarReManifestoGaiola`, manifestoGaiolaInput, httpOptions) as Observable<any>;
  }

  reimprimirReMT(obj: any): Observable<any> {
    return this.http.post<any[]>(`Gaiola/ReimprimirReMT`, obj, httpOptions);
  }

  imprimirMt(obj: any): Observable<any> {
    return this.http.get(`ManifestoTransferencia/ImprimirMT/${obj}`, httpOptions) as Observable<any>;
  }

  imprimirMtCompacto(obj: any): Observable<any> {
    return this.http.get(`ManifestoTransferencia/ImprimirMTCompacto/${obj}`, httpOptions) as Observable<any>;
  }

  podeIncluirPedidos(containerID: any): Observable<any> {
    return this.http.get(`Gaiola/podeIncluirPedidos/${containerID}`, httpOptions) as Observable<any>;
  }

  obterPedidosGaiola(obj: obterDadosPedidosGaiolaInput): Observable<obterDadosPedidosGaiolaOutput[]> {
    const filter = `${obj.containerUnique ? `containerUnique=${obj.containerUnique}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<obterDadosPedidosGaiolaOutput[]>(
      `Gaiola/obtenhaPedidosAssociadosGaiola?${filter}`,
      httpOptions
    );
  };

  associePedidoGaiola(obj: AssociarVolumeRequest): Observable<AssociarPedidoResponse> {
    return this.http.post(`Gaiola/associePedidoGaiola`, obj, httpOptions) as Observable<AssociarPedidoResponse>;
  };

  desassociarPedidoGaiola(obj: any): Observable<any> {
    return this.http.post(`Gaiola/desassociarPedidoGaiola`, obj, httpOptions) as Observable<any>;
  };

  listarLogGaiola(obj: obterLogsGaiolaInput): Observable<obterLogsGaiolaOutput[]> {
    const filter = `${obj.gaiola ? `gaiola=${obj.gaiola}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPagina ? `itensPagina=${obj.itensPagina}` : ''}`;
    return this.http.get<obterLogsGaiolaOutput[]>(
      `Gaiola/listarLogGaiola?${filter}`,
      httpOptions
    );
  };

  listarVolumesNaoCompletosGaiola(obj: obterVolumesNaoCompletosGaiolaInput): Observable<obterVolumesNaoCompletosGaiolaOutput> {
    const filter = `${obj.containerUnique ? `containerUnique=${obj.containerUnique}&` : ''}`
    return this.http.get<obterVolumesNaoCompletosGaiolaOutput>(
      `Gaiola/PedidosQueNaoEstaoCompletosNaGaiola?${filter}`,
      httpOptions
    );
  };

  listarPedidosGaiola(obj: obterProdutosGaiolaInput): Observable<ValidarManifestoTransferenciaResponse[]> {
    return this.http.get<ValidarManifestoTransferenciaResponse[]>(
      `Gaiola/VisualizarPedidosGaiola?${filtro(obj)}`,
      httpOptions
    );
  };

  listarIntervencaoGaiola(obj: obterProdutosGaiolaInput): Observable<ValidarManifestoTransferenciaResponse[]> {
    return this.http.get<ValidarManifestoTransferenciaResponse[]>(
      `Gaiola/VisualizarPedidosGaiolaComIntervencao?${filtro(obj)}`,
      httpOptions
    );
  };

  validaSePodeAssociarPedidos(containerUnique: number): Observable<VerificarAssociacaoPedidoResponse> {
    return this.http.get<VerificarAssociacaoPedidoResponse>(
      `Gaiola/ValidaSePodeAssociarPedidos?containerUnique=${containerUnique}`,
      httpOptions
    );
  };

  verificaSePodeRemoverItemDaGaiola(obj: VerificarDesassociacaoPedidoRequest) : Observable<VerificarDesassociacaoPedidoResponse> {
    return this.http.get<VerificarDesassociacaoPedidoResponse>(
      `Gaiola/VerificaSePodeRemoverItemDaGaiola?pedidoId=${obj.pedidoId}&pedEtiqueta=${obj.pedEtiqueta}`,
      httpOptions
    )
  }

  verificaCapacidadeAgente(AgenteId: number): Observable<any> {
    return this.http.get<any>(`ManifestoTransferencia/ConsultaCapacidadeAgente/${AgenteId}`, httpOptions)
  }

  listarIatas(obj: any): Observable<any[]> {
    return this.http.get<any[]>(
      `Gaiola/ListarIatasOrigem?${filtro(obj)}`,
      httpOptions
    );
  };

  listarGrids(iataDestinoId: any, iataOrigemId: any): Observable<any[]> {
    return this.http.get<any[]>(
      `Gaiola/ListarGrid/${iataDestinoId}/${iataOrigemId}`,
      httpOptions
    );
  };

}
